<dialog #mainModalDialog class="dialog">
  <div class="dialog-content-wrapper">
    <ng-content></ng-content>
  </div>
</dialog>
